import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Spin, Typography, notification } from 'antd';
import { CategoriesProxy } from '../services/catalogServiceAPI/categoriesProxy';
import { CategoryForm } from './CategoryForm';

const { Title } = Typography;

export function CreateCategory() {
    const history = useHistory();
    const proxy = useMemo(() => new CategoriesProxy(), []);
    const [categories, setCategories] = useState(null);

    useEffect(() => {
        proxy.list()
            .then(setCategories)
            .catch((e) => notification.error({ message: 'Failed to load categories', description: e.message }));
    }, [proxy]);

    const create = async (values) => {
        await proxy.create(values);
        notification.success({ message: 'Category created', description: 'It shows up on the next catalog load in the web and the app.' });
        history.push('/category');
    };

    if (!categories) return <div style={{ padding: 32 }}><Spin /></div>;
    return (
        <div style={{ padding: 24, maxWidth: 560 }}>
            <Title level={3}>Create Category</Title>
            <CategoryForm categories={categories} onSubmit={create} submitLabel="Add Category" />
        </div>
    );
}
